import { render, staticRenderFns } from "./LoginSignupButtons.vue?vue&type=template&id=6a471e54"
import script from "./LoginSignupButtons.vue?vue&type=script&lang=js"
export * from "./LoginSignupButtons.vue?vue&type=script&lang=js"
import style0 from "./LoginSignupButtons.vue?vue&type=style&index=0&id=6a471e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports